import { g_defaultOverlayNcode } from "../../common/constants/MapperConstants";
import { MappingStorage } from "../../common/mapper/MappingStorage";
import InkStorage from "../../common/penstorage/InkStorage";
export function getSOBPListForSave(options) {
    // defualt 옵션 처리
    let { emptyPod, emptyPublic } = options;
    if (emptyPod === undefined)
        emptyPod = true;
    if (emptyPublic === undefined)
        emptyPublic = false;
    const { surfaceOwnerIds: sids } = options;
    const msi = MappingStorage.getInstance();
    const is = InkStorage.getInstance();
    const maps = msi.rawData;
    const mapsTemp = msi.rawDataTemp;
    const pages = [];
    maps.arrDocMap.map(mapItem => mapItem.pages.map(page => pages.push(page)));
    mapsTemp.arrDocMap.map(mapItem => mapItem.pages.map(page => pages.push(page)));
    const sobps = [];
    pages.map(page => {
        const sobp = page.pageInfo;
        let including = true;
        const strokes = is.getPageStrokes(sobp);
        const isEmpty = strokes.length < 1;
        if (isEmpty) {
            if (!emptyPod && isPod(sobp))
                including = false;
            if (!emptyPublic && isPublic(sobp))
                including = false;
        }
        else {
            if (isOverlay(sobp))
                including = false;
            if (sids) {
                including = false;
                for (let i = 0, len = strokes.length; i < len; i++) {
                    const st = strokes[i];
                    if (st.surfaceOwnerId && sids.includes(st.surfaceOwnerId)) {
                        including = true;
                        break;
                    }
                }
            }
        }
        if (including)
            sobps.push(sobp);
    });
    return sobps;
}
function isPod(sobp) {
    if (sobp.section === 10 || sobp.section > 15)
        return true;
    return false;
}
function isOverlay(sobp) {
    if (sobp.section === g_defaultOverlayNcode.section)
        return true;
    return false;
}
function isPublic(sobp) {
    if (sobp.section !== 10)
        return true;
    return false;
}
//# sourceMappingURL=getSobpList.js.map